import { Component, effect, inject, OnDestroy, signal, ChangeDetectionStrategy } from "@angular/core";
import { SimplebarAngularModule } from "simplebar-angular";
import { HumidityStatisticsService } from "./facade/humidity-statistics.service";
import { AssetHierarchyComponent } from "../../../../shared/widgets/asset-hierarchy/asset-hierarchy.component";
import { HumidityChart } from "./components/humidity-chart/humidity-chart.component";
import { ChartChangeTimeEvent } from "../../../../models/ui/chartData";
import { ASSET_TYPES } from "../../../../enums/assetTypes.enum";
@Component({
  selector: "app-humidity-statistics",
  imports: [SimplebarAngularModule, HumidityChart, AssetHierarchyComponent],
  providers: [HumidityStatisticsService],
  templateUrl: "./humidity-statistics.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./humidity-statistics.component.scss",
})
export class HumidityStatisticsComponent implements OnDestroy {
  public humidityStatisticsFacade = inject(HumidityStatisticsService);

  public selectedAsset = signal<{ id: string; assetType: string } | null>(null);
  private lastSelectedTimeFrame?: ChartChangeTimeEvent;

  ngOnDestroy(): void {
    this.humidityStatisticsFacade.cleanup();
  }

  constructor() {
    effect(() => {
      const asset = this.selectedAsset();
      if (asset) {
        if (!this.lastSelectedTimeFrame) {
          this.humidityStatisticsFacade.loadInitialState(asset.id, asset.assetType);
        } else {
          this.humidityStatisticsFacade.updateChartForTimeRange(this.lastSelectedTimeFrame, asset);
        }
      }
    });
  }

  /**
   * Handles click on an asset in hierarchy and sets the asset for the chart if its a gate or building and not the same asset as the already selected one
   * @param event The event holding the data of the clicked asset
   */
  public onAssetSelected(event: { id: string; assetType: string }) {
    const asset = this.selectedAsset();
    if (
      [ASSET_TYPES.BUILDING, ASSET_TYPES.GATE_SYSTEM].includes(event.assetType as ASSET_TYPES) &&
      (event.id !== asset?.id || event.assetType !== asset?.assetType)
    ) {
      this.selectedAsset.set(event);
    }
  }

  /**
   * Handles change of timeframes and triggers chart update with new timeframe
   * @param event The event holding the data of the new timeframe
   */
  public onChangedTimeframe(event: ChartChangeTimeEvent) {
    this.lastSelectedTimeFrame = event;
    const asset = this.selectedAsset();
    if (asset) {
      this.humidityStatisticsFacade.updateChartForTimeRange(event, asset);
    }
  }
}
